import { useState, useEffect } from 'react';
import { getReviews } from '../lib/cmsClient';
import { COMPANY_INFO } from '../data/staticData';
import ReviewSlider from '../components/ReviewSlider';

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    async function load() {
      const data = await getReviews();
      setReviews(data);
    }
    load();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-20 lg:pt-24 pb-12 space-y-16">
      
      {/* Header */}
      <div className="text-left max-w-4xl space-y-4">
        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
          4,8 ud af 5,0 stjerner fra vores kunder
        </h1>
        <p className="text-stone-600 text-lg sm:text-xl leading-relaxed">
          Vi er stolte af at levere håndværksmæssigt korrekt arbejde, faste aftaler og pæn oprydning hver gang.
        </p>

        <div className="pt-2">
          <a
            href={COMPANY_INFO.ratingLink}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-none bg-stone-900 hover:bg-black text-white font-bold text-sm transition-all shadow-lg"
          >
            <span>Se alle 155+ anmeldelser på Anmeld Håndværker</span>
            <i className="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </div>
      </div>

      {/* Review Carousel */}
      <ReviewSlider />

    </div>
  );
}
